// Import Highway
import Highway from '@dogstudio/highway/src/highway';

// private statics
const curpage = null;

// class
export default class CustomRenderer extends Highway.Renderer {
    // constructor
    constructor(...args) {
        super(...args);
    }

    // methods
    onEnter() {
        // console.log('onEnter', this.properties.page.querySelector('body').classList);

        const $srcBody = this.properties.page.querySelector('body');
        document.body.className = $srcBody.className;

        // update page
        const $page = document.body.querySelector('.page');
        const $srcPage = $srcBody.querySelector('.page');

        if ($page && $srcPage) {
            $page.className = $srcPage.className;
        }

        $page.classList.add('page--has-highway');

        // language switcher
        const $newls = this.properties.page.querySelector('.language-switcher');
        const $ls = document.body.querySelector('.language-switcher');

        // $ls.innerHTML = $newls.innerHTML;

        // replace tabs when present
        const $oldActions = document.body.querySelector('.editor-actions');
        const $newActions = this.properties.page.querySelector('.editor-actions');
        if ($oldActions && $newActions) {
            $oldActions.parentNode.insertBefore($newActions, $oldActions);
            const $activetab = $newActions.querySelector(`a[href="${document.location.pathname}"]`);
            if ($activetab) $activetab.classList.add('is-active');
        }
        if ($oldActions) $oldActions.remove();
    }

    onLeave() {
        // console.log('onLeave', this.properties);
    }

    onEnterCompleted() {
        // console.log('onEnterCompleted', this.properties);
    }

    onLeaveCompleted() {
        // console.log('onLeaveCompleted', this.properties);
    }
}

// utils

// events
